import gql from 'graphql-tag';

import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const CHANGE_EVENT_POST_DETAILS_FRAGMENT = gql`
  fragment changeEventPostDetails on Post {
    id
    permalink
    currentUserRelation
    deleted
    plex {
      id
      name
      color
      currentUserRelation {
        ...fullPlexUserRelation
      }
    }
    title
    body
    publishStatus
    publishedDate
    author {
      id
      name
      picture
      jobTitle
    }
    labels {
      id
      name
    }
    type
    eventDate
    watching
  }

  ${FULL_PLEX_USER_RELATION_FRAGMENT}
`;
